<template>
  <div class="h5 pt-4">
    {{ $t('rawdata.tabs.tab2.siteVisit') }}
  </div>
  <div class="columns px-2">
    <div class="column is-4-desktop">
      <checkbox-two-level
        id="onOffGrid"
        :label="$t('rawdata.tabs.tab2.onOffGridHeader')"
        :data-list="filterOptions.onOffGrid"
        :values="onOffGrid"
        :css="'rawdata'"
        @update:check-result="selectGrid"
      />
    </div>
    <div class="column is-4-desktop">
      <checkbox-two-level
        id="rotation"
        :label="$t('rawdata.tabs.tab2.rotationHeader')"
        :data-list="filterOptions.rotation"
        :values="rotation"
        :css="'rawdata'"
        @update:check-result="selectRotation"
      />
    </div>
    <div
      v-if="false"
      class="column"
    >
      <checkbox-two-level
        id="multipleVisit"
        :label="$t('rawdata.tabs.tab2.multipleVisitHeader')"
        :data-list="filterOptions.multipleVisit"
        :values="mulitipleVisit"
        :css="'rawdata'"
        @update:check-result="selectMulitpleVisit"
      />
    </div>
  </div>
  <div class="h5 pt-4 pb-2">
    {{ $t('rawdata.tabs.selectRegion') }}
  </div>
  <div class="columns px-2">
    <div class="column">
      <choose-region
        :label="'test'"
        :main-data-list="filterOptions.region"
        :values="regions"
        @filters-updated="resetDownloadState"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CheckboxTwoLevel from '@/components/checkbox/CheckboxTwoLevel.vue';
import ChooseRegion from './ChooseRegion.vue';
import { rawdataState } from '@/composables/state/rawdataApp';

const {
  // state,
  filterOptions, rotation,
  onOffGrid,
  mulitipleVisit,
  regions,
  resetDownloadState
} = rawdataState();

/* when select all grid, unselect muli visit option */
const selectGrid = (selectedValues: string[]) => {
  onOffGrid.value = selectedValues;
  if (selectedValues.length > 0) {
    mulitipleVisit.value = [];
  }
  resetDownloadState();
};

/* when select all multipleVisit, unselect on off grid and rotation */
const selectMulitpleVisit = (selectedValues: string[]) => {
  mulitipleVisit.value = selectedValues;
  if (selectedValues.length > 0) {
    rotation.value = [];
  }
  resetDownloadState();
};
/* when select all rotation, unselect multipleVisit */
const selectRotation = (selectedValues: string[]) => {
  rotation.value = selectedValues;

  if (selectedValues.length > 0) {
    mulitipleVisit.value = [];
  }
  resetDownloadState();
};

</script>
<style scoped></style>

// https://abmi.ca/.ajax/rawdata/getRawdataFile?rawdata=106&offgridId=4&;jsessionid=1689784841304
